// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"ac72c5c6","981":"ca5e6641"}[chunkId] + ".chunk.js";
};